export const PRINT_STORE_ANALYTICS_ENTRY = 'analytics_page_print_store_entry'
export const FLOWLYTICS_FC_GEOGRAPHY_CHART = 'flowlytics_fc_geography_chart'
export const FLOWLYTICS_TOGGLE_ORG_DATA = 'flowlytics_toggle_org_data'
export const FLOWLYTICS_PAGINATED_TOP_CODES = 'flowlytics_paginated_top_codes'
export const FLOWLYTICS_FP_GEOGRAPHY_CHART = 'flowlytics_fp_geography_chart'
export const FLOWLYTICS_ANALYTICS_LANDING_PAGE_TEST = 'flowlytics_analytics_landing_page_test'
export const FLOWLYTICS_TOP_DESTINATIONS_CHART = 'flowlytics_top_destinations_chart'
export const FLOWLYTICS_ENHANCED_FILTERS = 'flowlytics_enhanced_filters'
export const FLOWLYTICS_TOP_PAGES_CHART = 'flowlytics_top_pages_chart'
export const FLOWLYTICS_SCHEDULED_ANALYTICS = 'flowlytics_scheduled_analytics'
export const FLOWLYTICS_REPORTS_FRESHNESS_BANNER = 'flowlytics_reports_freshness_banner'
export const FLOWLYTICS_PIXEL_WIZARD = 'flowlytics_pixel_wizard'
export const FLOWPAGE_PIXEL_PASSTHROUGH = 'flowpage_pixel_passthrough'
export const FLOWLYTICS_CONVERSIONS_PAGE = 'flowlytics_conversion_reports_page'
export const FLOWLYTICS_TOTAL_UNIQUE_SCANS_INDICATOR = 'flowlytics_total_unique_scans_indicator'
export const FLOWLYTICS_RAW_EVENTS = 'flowlytics_raw_events'
